/**
 * Returns the effective per-unit price for a variant at a given quantity,
 * based on tier breaks. Falls back to variant.price when no tiers present.
 */
export function tierUnitPrice(variant, qty) {
  if (!variant) return 0;
  const tiers = (variant.tiers || []).slice().sort((a, b) => a.min_qty - b.min_qty);
  if (tiers.length === 0) return Number(variant.price || 0);
  let effective = tiers[0].unit_price;
  for (const t of tiers) {
    if (qty >= t.min_qty) effective = t.unit_price;
  }
  return Number(effective);
}

export function tierSavings(variant, qty) {
  const list = Number(variant?.price || 0);
  const eff = tierUnitPrice(variant, qty);
  const saved = (list - eff) * qty;
  return Math.max(0, Math.round(saved * 100) / 100);
}

export function fmtUSD(n) {
  return `$${Number(n || 0).toFixed(2)}`;
}
